var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.openModal}},[(_vm.payload.tags == undefined || _vm.payload.tags.length == 0)?_c('img',{staticClass:"btn",attrs:{"src":"/edit_icon.svg","width":"24px"}}):_c('div',[_c('p',[_vm._v(_vm._s(_vm.payload.tags))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }